import React from "react";

const DecimalIcon = (props) => {
  const { default_color } = props;
  return (
    <svg
      viewBox="0 0 25 25"
      version="1.1"
      width="16"
      height="16"
      stroke="#955702"
      stroke-width="0.15"
      transform="matrix(1, 0, 0, 1, 0, 0)"
    >
      <path 
      stroke="#955702"
      fill="#955702"
     
        d="M10 7A3 3 0 0 0 7 10V13A3 3 0 0 0 13 13V10A3 
3 0 0 0 10 7M11 13A1 1 0 0 1 9 13V10A1 
1 0 0 1 11 10M17 7A3 3 0 0 0 14 10V13A3 3 0 0 0 20 
13V10A3 3 0 0 0 17 7M18 13A1 1 0 0 1 16 13V10A1 1 0 0 1 18 
10M6 15A1 1 0 1 1 5 14A1 1 0 0 1 6 15Z"
      />
    </svg>
  );
};

export default DecimalIcon;
